import { apiClient } from '@/services/apiClient';

export interface SystemMetrics {
  timestamp: string;
  memory: {
    heapUsedBytes: number;
    heapMaxBytes: number;
    nonHeapUsedBytes: number;
    nonHeapMaxBytes: number;
  };
  cpu: {
    processUsage: number | null;
    systemUsage: number | null;
    availableProcessors: number;
  };
  threads: {
    live: number | null;
    daemon: number | null;
    peak: number | null;
  };
  database: {
    activeConnections: number | null;
    idleConnections: number | null;
    maxConnections: number | null;
    pendingConnections: number | null;
  };
  uptime: {
    processUptimeSeconds: number | null;
    applicationReadyTimeSeconds: number | null;
    applicationStartedTimeSeconds: number | null;
  };
}

class SystemMetricsService {
  async getSystemMetrics(): Promise<SystemMetrics> {
    return apiClient.get<SystemMetrics>('/system/metrics');
  }
}

export const systemMetricsService = new SystemMetricsService();
